<template>
  <div class="page">
    <el-form size="small" label-width="100px" class="margin15-tb">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="短信费用(元)" >
            <el-input-number v-model="msgCost" :min="0" :step="0.1" :precision="2" controls-position="right" placeholder="请输入短信费用" style="width: 100%"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="语音费用(元)">
            <el-input-number v-model="ivrCost" :min="0" :step="0.1" :precision="2" controls-position="right" placeholder="请输入语音费用" style="width: 100%"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8" :offset="4">
          <el-button type="primary" size="small" @click="submitCompanyCost">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>

export default {
  props: [
    'companyIdTemp'
  ],
  data() {
    return {
      companyId: null,
      costId: null,
      msgCost: null,
      ivrCost: null
    };
  },
  watch: {
    companyIdTemp(companyId) {
      this.companyId = companyId;
      this.getCompanyCostInfo(companyId);
    }
  },
  methods: {
    getCompanyCostInfo(companyId) {
      this.$ajax({
        url: '/companyCost/getCompanyCostInfo',
        params: { companyId }
      }).then((res) => {
        console.warn(res);
        this.costId = res.data.id;
        this.msgCost = res.data.msgCost;
        this.ivrCost = res.data.ivrCost;
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    submitCompanyCost() {
      if (this.msgCost === 0) {
        this.$message({
          type: 'error',
          message: '短信费用不能为零'
        });
        return;
      }
      if (this.ivrCost === 0) {
        this.$message({
          type: 'error',
          message: '语音费用不能为零'
        });
        return;
      }
      this.$ajax({
        prompt: true,
        url: '/companyCost/addOrUpdateCompanyCost',
        data: {
          id: this.costId,
          companyId: this.companyId,
          msgCost: this.msgCost,
          ivrCost: this.ivrCost
        }
      }).then((res) => {
        console.warn(res);
        this.getCompanyCostInfo(this.companyId);
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/page/main/company/billing_set.vue